var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-background2"},[_c('CustomCursor',{staticClass:"hidden sm:block"}),_c('div',{staticClass:"max-w-screen-2xl m-auto"},[_c('div',{staticClass:"flex justify-center items-center h-screen"},[_c('div',{staticClass:"relative 2xl:h-[90%] h-full w-full bg-background1 shadow-2xl"},[_c('router-view'),_c('Toast')],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }